















































































import { computed, defineComponent, PropType } from 'vue';
import KeywordHighlight from 'vue-text-highlight';
import WordHighlight from './WordHighlight.vue';
import Icon from '../../../shared/components/Icon.vue';
import ImageThumbnail from '../../../shared/PageFragments/Media/ImageThumbnail.vue';
import VideoThumbnail from '../../../shared/PageFragments/Media/VideoThumbnail.vue';
import SoundThumbnail from '../../../shared/PageFragments/Media/SoundThumbnail.vue';
import { mediaTypes } from '../../../shared/enums/mediaTypes';
import { iconClassEnum } from '../../../shared/enums/iconClassEnum';
import { ScanningStatusEnum } from '../../../shared/enums/scanningStatus.enum';
import { SearchMediaResult } from '../../../shared/models/responses/search/findGeneric.response';
import { mapSearchMediaResultToMediaModel } from '../../business/search/mapSearchMediaResultToMediaModel';
import { useMediaScan } from '../../../shared/composables/useMediaScan';
import { useSearchResultMedia } from '../../composables/global_search/useSearchResultMedia';

export default defineComponent({
  name: 'SearchResultItemMedia',
  components: {
    KeywordHighlight,
    Icon,
    ImageThumbnail,
    VideoThumbnail,
    SoundThumbnail,
  },
  props: {
    media: {
      type: Object as PropType<SearchMediaResult>,
      required: true,
    },
    searchString: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const mediaModel = computed(() => mapSearchMediaResultToMediaModel(props.media));
    const { scanningText, scanningStatus } = useMediaScan(mediaModel);

    const {
      searchQueries,
      showTitle,
      showDescription,
      showAlbumDescription,
      showTags,
      descriptionExcerpt,
      albumDescriptionExcerpt,
      creatorName,
      albumTitle,
      uploadedDate,
      visibleTags,
      hasMoreTags,
      additionalTagCount,
      openMedia,
    } = useSearchResultMedia(
      () => props.media,
      () => props.searchString,
      media => emit('openMedia', media)
    );

    return {
      WordHighlight,
      mediaModel,
      mediaTypes,
      iconClassEnum,
      ScanningStatusEnum,
      scanningText,
      scanningStatus,
      searchQueries,
      showTitle,
      showDescription,
      showAlbumDescription,
      showTags,
      descriptionExcerpt,
      albumDescriptionExcerpt,
      creatorName,
      albumTitle,
      uploadedDate,
      visibleTags,
      hasMoreTags,
      additionalTagCount,
      openMedia,
    };
  },
});
